import {LogReportApiPrefix as logApi} from '~/utils/restApi'
import {pcDownloadFile} from '~/utils/files'

export const state = () => ({
  currentStatusDownload: `${logApi}/current_status/save`,
  fwStatus: `${logApi}/current_status/session_stat`,
  vpnStatus: `${logApi}/current_status/vpn_stat`,
  vpnTunnelStatus: `${logApi}/current_status/vpn_tunnel_stat`,
  vpnTunnelInfo: `${logApi}/current_status/vpn_tunnel_info`,
  fwStatusList: [],
  vpnStatusList: [],
  pageSize: 30,
  totalDataCount: 0,
  currentIndex: 1, // 현재 페이지
  currentType: _.noop(), // 상태 타입
  selectMgrId: _.noop(), // 선택한 장비 아이디
  filters: []
})

export const mutations = {
  clearPatchHistoryData (state) {
    state.selectMgrId = _.noop()
    state.pageSize = 30
    state.fwStatusList = []
    state.vpnStatusList = []
    state.totalDataCount = 0
    state.currentIndex = 1
    state.filters = []
    state.totalDataCount = 0
    state.currentType = _.noop()
  },
  clearInit (state) {
    // 타입이 변경될때 초기화
    state.fwStatusList = []
    state.vpnStatusList = []
    state.totalDataCount = 0
    state.currentIndex = 1
    state.filters = []
    state.totalDataCount = 0
  },
  setCurrentType (state, data) {
    state.currentType = data
  },
  setFilters (state, data) {
    state.filters = data
  },
  setFireWallStatusList (state, data) {
    const result = _.cloneDeep(data)
    state.totalDataCount = result.total_cnt
    state.fwStatusList = result.data
  },
  setVpnStatusList (state, data) {
    const result = _.cloneDeep(data)
    state.totalDataCount = result.total_cnt
    state.vpnStatusList = result.data
  },
  setErrorMessage (state, data) {
    state.errorMessage = data.msg || ''
  },
  setPageSize (state, pageCnt) {
    state.pageSize = pageCnt
  },
  setCurrentIndexPage (state, idx) {
    state.currentIndex = idx
  },
  setSelectMgrId (state, id) {
    state.selectMgrId = id
  }
}

export const actions = {
  async getFireWallStatusList ({commit, state}, {movePage = false} = {}) {
    const param = {}
    param.device_id = state.selectMgrId // Device ID
    param.depth_level = 'N' //  일반 조회 "N", 페이지 이동 시: "0"
    param.offset = 0
    param.data_cnt = state.pageSize // Page Per Count
    param.page_number = 1
    param.total_cnt = 100000
    // 변동 없는 Parameters 기능 추가 시 변경
    param.filters = state.filters
    param.data_type = state.currentType // vpn Status
    param.view_type = 1 // Default 1

    // 페이지 이동일 경우
    if (movePage) {
      param.page_number = state.currentIndex // 현재 페이지
      param.depth_level = '0'
      param.offset = param.data_cnt * (param.page_number - 1)
    }
    const msg = {loading: true, applyMsg: false, successAlert: false}
    const res = await this.$axios.$post(state.fwStatus, param, msg)
    if (res.code === 'ok') {
      commit('setFireWallStatusList', res.result)
    }
    return res
  },
  async getVpnStatusList ({commit, state}, {movePage = false} = {}) {
    const param = {}
    param.device_id = state.selectMgrId // Device ID
    param.depth_level = 'N' //  일반 조회 "N", 페이지 이동 시: "0"
    param.offset = 0
    param.data_cnt = state.pageSize // Page Per Count
    param.page_number = 1
    param.total_cnt = 100000
    // 변동 없는 Parameters 기능 추가 시 변경
    param.filters = state.filters
    param.data_type = state.currentType // vpn Status
    param.view_type = 1 // Default 1
    let url = ''
    switch (state.currentType) {
      case 'vpn_line_status':
        url = state.vpnStatus
        break
      case 'vpn_tunnel_status':
        url = state.vpnTunnelStatus
        break
      case 'vpn_branch_info':
        url = state.vpnTunnelInfo
        break
      default:
        url = ''
        break
    }
    // 페이지 이동일 경우
    if (movePage) {
      param.page_number = state.currentIndex // 현재 페이지
      param.depth_level = '0'
      param.offset = param.data_cnt * (param.page_number - 1)
    }
    const msg = {loading: true, applyMsg: false, successAlert: false}
    const res = await this.$axios.$post(url, param, msg)
    if (res.code === 'ok') {
      commit('setVpnStatusList', res.result)
    }
    return res
  },
  async fileSave ({commit, state}, param) {
    const params = {}
    params.device_id = state.selectMgrId
    params.data_cnt = state.pageSize
    params.data_type = state.currentType
    params.depth_level = 'N' //  일반 조회 "N", 페이지 이동 시: "0"
    params.filters = state.filters
    params.offset = 0
    // 변동 없는 Parameters 기능 추가 시 변경
    params.total_cnt = 100000
    params.view_type = 1 // Default 1
    params.titles = param.value // param.key: field name, param.value: field title
    const msg = {
      responseType: 'blob',
      method: 'get',
      returnErr: true,
      loading: true,
      applyMsg: false,
      successAlert: false
    }
    const data = await this.$axios.$file(state.currentStatusDownload, params, msg)
    if (data.code !== undefined) {
      const blob = new Blob([data.data])
      const reader = new FileReader()
      const _this = this
      reader.onload = () => {
        const msgObj = JSON.parse(reader.result)
        const msgTxt = msgObj.result.msg
        _this.$router.app.$alertPopUp.show(msgTxt)
      }
      reader.readAsText(blob)
    }
    let nameData = data.fileName
    if (data.fileName !== undefined) {
      if (nameData.indexOf('UTF-8') > -1) {
        nameData = data.fileName.replace('UTF-8\'\'', '')
      }
      nameData = decodeURI(nameData)
      pcDownloadFile(data.data, nameData)
    }
  }
}

export const getters = {}
